import { render } from "./Asset.vue?vue&type=template&id=3c0b1cd4&scoped=true&ts=true"
import script from "./Asset.vue?vue&type=script&lang=ts"
export * from "./Asset.vue?vue&type=script&lang=ts"

import "./Asset.vue?vue&type=style&index=0&id=3c0b1cd4&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0b1cd4"]])

export default __exports__